import React, { ReactNode } from 'react';
import { Grid, Box } from '@mantine/core';
import '../../watchly-theme.css';
import Logo from '../Logo';
import HyperspaceBackground from '../HyperspaceBackground';

interface AuthLayoutProps {
    children: ReactNode;
}

/**
 * The auth shell is always dark, whatever the app's colour scheme.
 *
 * Mantine's component rules key off `[data-mantine-color-scheme]` as a plain
 * descendant selector, so stamping it on the wrapper makes every control inside
 * resolve its dark variant — without that, a light-mode session gave the inputs
 * a white background. The matching semantic variables (text, placeholder,
 * dimmed) are only defined on `:root`, so watchly-theme.css redefines those on
 * `.auth-theme`. Both halves are needed.
 */
const AuthLayout = ({ children }: AuthLayoutProps) => {
    return (
        <div
            className="auth-theme"
            data-mantine-color-scheme="dark"
            style={{ background: 'var(--background)', minHeight: '100vh' }}
        >
            <Grid gutter={0} styles={{ inner: { minHeight: '100vh' } }}>
                <Grid.Col
                    span={{ base: 12, md: 5 }}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 'clamp(1.5rem, 4vw, 3rem)',
                        backgroundColor: '#1c1c1c',
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        className="auth-surface-card"
                        style={{
                            position: 'relative',
                            width: '100%',
                            maxWidth: 440,
                            padding: 'clamp(1.75rem, 4vw, 2.75rem)',
                        }}
                    >
                        {children}
                    </Box>
                </Grid.Col>
                <Grid.Col
                    span={{ base: 12, md: 7 }}
                    style={{
                        minHeight: 'clamp(200px, 32vh, 100%)',
                        backgroundColor: 'var(--background)',
                        padding: 0,
                    }}
                    visibleFrom="md"
                >
                    <HyperspaceBackground>
                        <Logo size="xl" forceDark />
                    </HyperspaceBackground>
                </Grid.Col>
            </Grid>
        </div>
    );
};

export default AuthLayout;
